export const convertCPForCNPJStringToNumbers = (value: string) => {
  return value.replace(/\D/g, '')
}
